import axios from "axios";

const createScheduleCustomer = async (plan) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/TechScheduleCus`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getAllScheduleCustomer = async (param) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechScheduleCus${param || ""}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getScheduleCustomer = async (id) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/TechScheduleCus/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const editScheduleCustomer = async (id, plan) => {
  return axios
    .patch(`${process.env.REACT_APP_API_URL}/TechScheduleCus/${id}`, plan)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteScheduleCustomer = async (id) => {
  return axios
    .delete(
      `${process.env.REACT_APP_API_URL}/TechScheduleCus/${id}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const TechScheduleCusService = {
  createScheduleCustomer,
  getAllScheduleCustomer,
  getScheduleCustomer,
  editScheduleCustomer,
  deleteScheduleCustomer
};

export default TechScheduleCusService;
